import * as React from 'react';
import style from './style.module.scss';

export default function AppBar({
  active,
  onClick,
  datas,
}: {
  active?: string;
  onClick?: (data: string) => void;
  datas?: { [key: string]: string }[];
}): JSX.Element {
  const handleClick = (data: string) => {
    if (onClick) {
      onClick(data);
    }
  };

  return (
    <section id="footer_menu_utama">
      <div className={style.container_footer}>
        <div className={style.navigation_menu}>
          {datas?.map((item: { [key: string]: string }, index: number) => (
            <div
              key={index}
              className={style.box_menu}
              style={{
                background: active === item.link ? 'F6FBFF' : '#FFF',
              }}
              onClick={() => {
                handleClick(item.link);
              }}
              id="nav-menu"
            >
              <img
                src={
                  active === item.link ? item.imageActive : item.imageInactive
                }
                alt={item.label}
                width={20}
                height={20}
              />
              <div
                className={style.text_label}
                style={{
                  color: active === item.link ? '#1078CA' : '#BDBDBD',
                }}
              >
                {item.label}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
